// extracted by mini-css-extract-plugin
module.exports = {"control":"nwea-ds-v1-toggle-control","icon":"nwea-ds-v1-toggle-icon","container":"nwea-ds-v1-toggle-container","label":"nwea-ds-v1-toggle-label"};